let ctx = null;
let analyser = null;
let currentAudio = null;
const ampListeners = new Set();
const stateListeners = new Set();
let state = "idle"; // idle | loading | playing

function setState(s) {
  state = s;
  stateListeners.forEach((cb) => cb(s));
}

export function getSpeechState() {
  return state;
}

export function onState(cb) {
  stateListeners.add(cb);
  return () => stateListeners.delete(cb);
}

export function onAmp(cb) {
  ampListeners.add(cb);
  return () => ampListeners.delete(cb);
}

function ensureCtx() {
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    ctx = new AC();
    analyser = ctx.createAnalyser();
    analyser.fftSize = 256;
    const data = new Uint8Array(analyser.frequencyBinCount);
    const loop = () => {
      if (analyser) {
        analyser.getByteFrequencyData(data);
        let sum = 0;
        for (let i = 0; i < data.length; i++) sum += data[i] * data[i];
        const amp = Math.sqrt(sum / data.length) / 255;
        ampListeners.forEach((cb) => cb(amp));
      }
      requestAnimationFrame(loop);
    };
    loop();
  }
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
}

export function stopSpeaking() {
  if (currentAudio) {
    try {
      currentAudio.pause();
    } catch {}
    currentAudio = null;
  }
  setState("idle");
}

export async function speakBlob(blob) {
  stopSpeaking();
  setState("loading");
  try {
    const audio = new Audio(URL.createObjectURL(blob));
    currentAudio = audio;
    audio.onended = () => setState("idle");
    const c = ensureCtx();
    await audio.play();
    if (c && analyser) {
      try {
        const src = c.createMediaElementSource(audio);
        src.connect(analyser);
        analyser.connect(c.destination);
      } catch {}
    }
    setState("playing");
    return audio;
  } catch (e) {
    setState("idle");
    throw e;
  }
}

export async function speakUrl(url) {
  stopSpeaking();
  setState("loading");
  try {
    const audio = new Audio(url);
    currentAudio = audio;
    audio.onended = () => setState("idle");
    const c = ensureCtx();
    await audio.play();
    if (c && analyser) {
      try {
        const src = c.createMediaElementSource(audio);
        src.connect(analyser);
        analyser.connect(c.destination);
      } catch {}
    }
    setState("playing");
    return audio;
  } catch (e) {
    setState("idle");
    throw e;
  }
}
